$ = require 'jquery'
CalendarMonthDayView = require 'views/calendar/calendar-month-day-view'
CalendarView = require 'views/calendar/calendar-view'
Controller = require 'controller'
Dates = require 'lib/dates'
DragSort = require 'views/lib/drag-sort'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
templates = require 'views/internal/templates'
moment = require 'moment'

module.exports = class CalendarMonthView extends CalendarView
  className: Util.extendParentClassName('calendar-month')
  WEEK_WRAPPER_ELEMENT: 'tr'
  VIEWSTATE_PREF_STR: 'month'
  HEADER_CLASS_NAME: 'month-view'
  # Must be >= 5 to ensure scrolling down/up via the buttons will always have
  # the next month in view
  WEEKS_FROM_EDGE_BEFORE_RENDER_NEW_DAYS: 5
  # Looks smoothest when it matches WEEKS_FROM_EDGE_BEFORE_RENDER_NEW_DAYS
  WEEKS_TO_RENDER_UPON_SCROLL_THRESHHOLD: 5
  MINIMUM_WEEKS_KEPT_IN_DOM: 20

  initialize: ->
    super
    @DAY_VIEW_TYPE = CalendarMonthDayView
    @today = new Date()
    @currentMonthCells = []
    @scrollLock = false
    @weeksKeptInDOM = @MINIMUM_WEEKS_KEPT_IN_DOM
    @makeDebouncedMethods('shadeDaysUpdateHeader')

  render: (day = @today) ->
    @$el.html(templates.fill('calendar_month'))
    @renderBaseWeek(day)
    @currentCenterWeek = day
    @currentMonth = Dates.getFirstOfMonth(day)
    weeksToRender = Math.floor(@weeksKeptInDOM / 2)
    @renderWeeks(weeksToRender)
    @renderWeeks(-1 * weeksToRender)
    @shadeDays()
    @setSubscriptions()
    @

  getDayView: (day, options) ->
    super(day, _.extend({ scrollIntoView: @scrollIntoView.bind(@) }, options))

  addedToDOM: ->
    super
    @calculateVariables()
    @windowResizeCheck()
    @updateHeader()
    @scrollToDay(@currentCenterWeek)

  updateRoute: ->
    { year, month } = Dates.dateToObj @currentMonth
    month = Util.lpad month, 2, '0'
    Controller.setBoardLocation(
      @model.id,
      'calendar',
      [year, month],
      { replace: true }
    )

  setSubscriptions: ->
    @stopSubscriptions()
    $(WindowSize).on "windowClassChange.#{ @uniqueId() }",
      @windowClassChangeCheck.bind(@)
    $(window).on "resize.#{ @uniqueId() }", =>
      @windowResizeCheck()
    # Scroll does not bubble up, so it cannot use Backbone shortcut binding
    $('.calendar-month').on "scroll.#{ @uniqueId() } ", =>
      @scrollCheck()

  stopSubscriptions: ->
    $(WindowSize).off(".#{ @uniqueId() }")
    $(window).off(".#{ @uniqueId() }")
    $('.calendar-month').off(".#{ @uniqueId() }")

  windowClassChangeCheck: (e, classNames) ->
    if WindowSize.fSmall
      # Close expanded days when switching to/from small window
      $('.calendar-day.active').removeClass('active')
      storedCurrentWeek = new Date(@currentCenterWeek)
      @calculateVariables()
      @windowResizeCheck()
      @scrollCheck()
      @scrollToDay(storedCurrentWeek)

  calculateVariables: ->
    @tableSpacing = parseInt(@$('.calendar-table').css('border-spacing')) ? 5
    @dayCellHeight = @$('.day-cell').prop('clientHeight') + @tableSpacing

  windowResizeCheck: ->
    # we cannot simply do $('.calendar-content').outerHeight() because during window
    # class transitions, $(.calendar-content) sometimes has a height of zero for an instant
    windowHeight = $(window).outerHeight()
    headerHeight = $('#header').outerHeight()
    boardHeaderHeight = $('#board-header').outerHeight()
    calHeaderHeight = $('.calendar-header').outerHeight()
    @calendarContentHeight = windowHeight - (headerHeight + boardHeaderHeight + calHeaderHeight)

    # When the window size is especially tall, we adjust the @weeksKeptInDOM
    # so there is a comfortable amount of scrollbar space.  We do not let
    # @weeksKeptInDOM below @MINIMUM_WEEKS_KEPT_IN_DOM because there would be
    # cycles of rendering/deleting views because the threshhold is too small.
    numVisibleWeeks = Math.ceil(@calendarContentHeight / @dayCellHeight)
    @weeksKeptInDOM = Math.max(numVisibleWeeks * 5, @MINIMUM_WEEKS_KEPT_IN_DOM)

    return

  updateHeader: ->
    header = "#{ moment(@currentMonth).format('MMMM YYYY') }"
    $('.js-calendar-header').text(header)

  renderBaseWeek: (day) ->
    $weekRowEl = @weekRowEl(day)
    $('.calendar-month').off(".#{ @uniqueId() }")
    @$('.calendar-table').append($weekRowEl)
    @calculateFirstAndLastWeeksFromDOM()

  renderWeeks: (numWeeks) ->
    if numWeeks > 0
      targetSaturday = moment(@lastRenderedSaturday).add(numWeeks, 'weeks').toDate()
      @renderUpToDay(targetSaturday)

    if numWeeks < 0
      targetSunday = moment(@firstRenderedWeek).add(numWeeks, 'weeks').toDate()
      @renderUpToDay(targetSunday)

  renderUpToDay: (day) ->
    $calendarTable = @$('.calendar-table')

    targetSaturday = Dates.getEndOfWeek(day)
    weeksToAppend = []
    while @lastRenderedSaturday < targetSaturday
      @lastRenderedSaturday = moment(@lastRenderedSaturday).add(1, 'weeks').toDate()
      weeksToAppend.push(@weekRowEl(@lastRenderedSaturday))
    $calendarTable.append(weeksToAppend)

    targetSunday = Dates.getStartOfWeek(day)
    weeksToPrepend = []
    while @firstRenderedWeek > targetSunday
      @firstRenderedWeek = moment(@firstRenderedWeek).subtract(1, 'weeks').toDate()

      weeksToPrepend.unshift(@weekRowEl(@firstRenderedWeek))
    $calendarTable.prepend(weeksToPrepend)
    @scroll(@dayCellHeight * weeksToPrepend.length)

    @deleteExcessWeeks()
    @calculateFirstAndLastWeeksFromDOM()

  deleteExcessWeeks: ->
    $weeks = $('.week')
    if $weeks.length > @weeksKeptInDOM
      tableHeight = @$('.calendar-table').outerHeight()
      scrollTop = $('.calendar-month').prop('scrollTop')
      inTopHalf = scrollTop < tableHeight / 2

      if inTopHalf # remove weeks from the bottom
        for i in [$weeks.length - 1..@weeksKeptInDOM]
          $($weeks[i]).remove()
      else # remove weeks from the top
        excessWeeks = $weeks.length - @weeksKeptInDOM
        @scroll(-1 * @dayCellHeight * excessWeeks)
        for i in [0...excessWeeks]
          $($weeks[i]).remove()

  # Scrolls the passed in day to the middle of the screen
  scrollToDay: (day, speed) ->
    if !@scrollLock
      halfScreenNumWeeks = (@calendarContentHeight / 2) / @dayCellHeight
      weekStart = moment(day).startOf('week')
      firstRequiredWeek = weekStart.clone().subtract(Math.ceil(halfScreenNumWeeks), 'weeks').toDate()
      lastRequiredWeek = weekStart.clone().add(Math.ceil(halfScreenNumWeeks), 'weeks').toDate()

      if @firstRenderedWeek <= firstRequiredWeek && @lastRenderedWeek >= lastRequiredWeek
        targetScrollDay = weekStart.clone().subtract(Math.floor(halfScreenNumWeeks), 'weeks').toDate()
        dateInt = Dates.getMidnightInt(targetScrollDay)
        $targetDayCell = @$("[name='#{ dateInt }']")
        offsetTop = $targetDayCell.prop('offsetTop')

        # Plus 1 pixel looks nicer in mobile view
        @scrollTo(offsetTop - @tableSpacing + 1, speed)
      else
        @render(day)
        @addedToDOM()
        @delegateEvents()
      @updateRoute()

  completeAnimatedScroll: ->
    @enableRenderNewDays()

  scrollIntoView: ({ top, height }) ->
    bottom = top + height
    $scrollArea = $('.calendar-month')
    scrollTop = $scrollArea.scrollTop()
    scrollBottom = scrollTop + $scrollArea.height()

    if top < scrollTop
      @scroll(top - scrollTop - @tableSpacing + 1, @SCROLL_ANIMATION_TIME)
    else if bottom > scrollBottom
      @scroll(bottom - scrollBottom + @tableSpacing + 1, @SCROLL_ANIMATION_TIME)

  scroll: (pixels, speed) ->
    $scrollArea = $('.calendar-month')
    currentScroll = $scrollArea.prop('scrollTop')
    @scrollTo(currentScroll + pixels, speed)

  scrollTo: (scrollTop, speed) ->
    $scrollArea = $('.calendar-month')
    if speed
      @scrollLock = true
      $scrollArea.animate(
        { scrollTop: scrollTop },
        { duration: speed, complete: (=> @completeAnimatedScroll()) }
      )
    else
      $scrollArea.scrollTop(scrollTop)

  navigatePrevious: -> @scrollMonth(-1)
  navigateNext: -> @scrollMonth(1)

  scrollMonth: (numMonths) ->
    if !@scrollLock
      # Lock rendering new days while scrolling to prevent erratic behavior due
      # to scroll checking while scrolling
      middleOfMonth = moment(@currentMonth)
        .add(numMonths, 'months')
        .startOf('month')
        .add(15, 'days')
        .toDate()

      @scrollToDay(middleOfMonth, @SCROLL_ANIMATION_TIME)

  enableRenderNewDays: ->
    @checkRenderDays()
    @scrollLock = false

  scrollCheck: ->
    # Hide cardViewMenu when we scroll, otherwise original card position changes
    # while menu remains in place
    PopOver.hide()

    $scrollArea = $('.calendar-month')
    areaHeight = $scrollArea.outerHeight()
    scrollTop = $scrollArea.prop('scrollTop')

    if !@scrollLock
      @checkRenderDays()

    # Check if we need to update the currentCenterWeek or currentMonth
    centerOfScreen = areaHeight / 2
    weeksSinceFirstSunday = Math.floor((scrollTop + centerOfScreen) / @dayCellHeight)
    screenCenterWeekStart = moment(@firstRenderedWeek).add(weeksSinceFirstSunday, 'weeks').toDate()

    # If the new week is different from the old
    if !moment(@currentCenterWeek).isSame(screenCenterWeekStart, 'day')
      @currentCenterWeek = screenCenterWeekStart
      endOfCenterWeek = Dates.getEndOfWeek(@currentCenterWeek)
      # If any part of the new week has a different month from the old month
      if @currentMonth.getMonth() != @currentCenterWeek.getMonth() ||
          @currentMonth.getMonth() != endOfCenterWeek
        # Bias the month selection to today's month
        if endOfCenterWeek.getMonth() == @today.getMonth()
          @currentMonth = Dates.getFirstOfMonth(endOfCenterWeek)
        else
          @currentMonth = Dates.getFirstOfMonth(@currentCenterWeek)
        @shadeDaysUpdateHeaderDebounced()
      @updateRoute()

    # Set the today-button className
    todayID = Dates.getMidnightInt(@today)
    $todayCell = @$("[name='#{ todayID }']")
    todayOffsetTop = $todayCell.prop('offsetTop')

    onToday =
      todayOffsetTop < centerOfScreen + scrollTop < todayOffsetTop + @dayCellHeight
    $('.today-button').toggleClass('on-today', onToday)

  shadeDaysUpdateHeader: ->
    @updateHeader()
    @shadeDays()

  checkRenderDays: ->
    $scrollArea = $('.calendar-month')
    areaHeight = $scrollArea.outerHeight()
    scrollTop = $scrollArea.prop('scrollTop')

    tableHeight = @$('.calendar-table').outerHeight()
    distFromBottom = tableHeight - areaHeight - scrollTop

    # How far from the edge before we generate new day views
    scrollEdgeThreshhold = @dayCellHeight * @WEEKS_FROM_EDGE_BEFORE_RENDER_NEW_DAYS

    if distFromBottom < scrollEdgeThreshhold
      mustRefreshDrag = true
      @renderWeeks(@WEEKS_TO_RENDER_UPON_SCROLL_THRESHHOLD)
    if scrollTop < scrollEdgeThreshhold
      mustRefreshDrag = true
      @renderWeeks(-1 * @WEEKS_TO_RENDER_UPON_SCROLL_THRESHHOLD)
    if mustRefreshDrag && @model.editable()
      # Very slow, so defer it until after render finishes
      @defer ->
        DragSort.refreshCalendarCardSortable()

  shadeDays: ->
    $cells = @$('.day-cell')
    $(cell).removeClass('current-month') for cell in @currentMonthCells

    @currentMonthCells = _.filter $cells, @cellInCurrentMonth, @
    $(cell).addClass('current-month') for cell in @currentMonthCells

  cellInCurrentMonth: (cell) ->
    dateInt = parseInt $(cell).attr('name')
    new Date(dateInt).getMonth() == @currentMonth.getMonth()



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-month-view.coffee